export const generateArrayFromPath = (path: string) =>
  path.split('/').filter((n) => n);
